export interface ImageSize {
  width: number;
  height: number;
}

export const NO_IMAGE_SIZE: ImageSize = { width: 0, height: 0 };

/**
 * Display size for an image of known intrinsic dimensions, fitted to the
 * narrower of the device and the caller's cap.
 */
export const scaleToWidth = (
  intrinsicWidth: number,
  intrinsicHeight: number,
  deviceWidth: number,
  maxWidth: number
): ImageSize => {
  const width = deviceWidth <= maxWidth ? deviceWidth : maxWidth;

  return { width, height: (width / intrinsicWidth) * intrinsicHeight };
};

export const hasIntrinsicSize = (intrinsicSize?: ImageSize): boolean =>
  !!intrinsicSize && intrinsicSize.width > 0 && intrinsicSize.height > 0;
